import { fmt } from "../lib/api";
import { useFetch } from "../lib/useFetch";
import { Panel, Spinner } from "./common";

export const UsFit = () => {
  const { data } = useFetch("/fees/us-fit");
  return (
    <Panel title="US stocks that fit your risk per trade (fractional)" className="mb-3" testid="us-fit">
      {!data ? <Spinner /> : (
        <>
          <p className="mb-2 text-xs text-slate-600" data-testid="us-fit-budget">
            Risk per trade RM{fmt(data.risk_budget_myr, 2)} · {data.rows.filter((r) => r.fits).length} of {data.rows.length} US stocks fit · {data.rows.filter((r) => r.whole_share_fits).length} also fit with whole shares.
          </p>
          <div className="custom-scrollbar max-h-96 overflow-auto"><table className="tbl w-full" data-testid="us-fit-table">
            <thead><tr><th>Stock</th><th>Price</th><th>Stop distance</th><th>Qty</th><th>Trade RM</th><th>Risk incl. fees</th><th>Fees in+out</th><th>Fees share of risk</th><th>Whole share?</th></tr></thead>
            <tbody>{data.rows.map((r) => (
              <tr key={r.symbol} data-testid={`us-fit-row-${r.symbol}`} className={r.fits ? "" : "opacity-60"}>
                <td><span className="mono font-semibold">{r.symbol}</span> <span className="text-[10px] text-slate-500">{r.name}</span></td>
                <td className="mono">${fmt(r.price, 2)}</td><td className="mono">${r.stop_dist}</td>
                <td className="mono font-bold" data-testid={`us-fit-qty-${r.symbol}`}>{r.qty}</td><td className="mono">{fmt(r.notional_myr, 2)}</td>
                <td className="mono">RM{fmt(r.risk_myr, 2)}</td><td className="mono">RM{fmt(r.fees_myr, 2)}</td>
                <td className={`mono ${r.fee_share_pct > 50 ? "text-red-600" : "text-amber-600"}`}>{r.fee_share_pct}%</td>
                <td className="mono text-[10px]">{r.whole_share_fits ? "yes" : "fractional only"}</td>
              </tr>))}
            </tbody></table></div>
          <p className="mt-2 text-[10px] text-slate-500">{data.note} US fees have a minimum per order, so about a third of every RM25 risk goes to fees on these trade sizes.</p>
        </>
      )}
    </Panel>
  );
};
